import apiList from "@/service/basic/orderDepositApi";
import { api } from "@/service/api";
import { Message } from "element-ui";
const myhost = hostname;

// 定金单列表
export function queryList(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.queryList}`, params)
      .then(res => {
        if (res && res.code == 200) {
          resolve(res.data);
        } else {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 定金单Tab统计订单数
export function getTotalNum(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.getTotalNum}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 导出定金单
export function exportData(params) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.exportDepositData}`, params)
      .then(res => {
        if (res.message === "Success") {
          Message.success("定金单报表导出成功，请在报表中心查看下载！");
        }

        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/orderDeposit.js